import { createSlice } from '@reduxjs/toolkit';
import apiZalo from '../../api/zalo';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  sidebarChat: [],
  conversationContent: [],
  infoUserSelected: false,
  endPage: false,
  endListChat: false
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'conversation_zalo',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // ACCESS ZALO
    statusRefreshInfo(state, action) {
      state.infoUserSelected = false;
      state.conversationContent = [];
    },
    statusSidebarChatSuccess(state, action) {
      const participants = action.payload;
      state.sidebarChat = participants;
      state.isLoading = false;
    },
    // ACCESS ZALO
    statusGetConversationSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent = participants;
      state.endPage = false;
      state.isLoading = false;
    },
    // ACCESS ZALO
    statusLoadMoreMessageSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent = participants.concat(state.conversationContent)
      state.endPage = false;
      state.isLoading = false;
    },
    // ACCESS ZALO
    statusIsSelectedSuccess(state, action) {
      const participants = action.payload;
      state.infoUserSelected = participants;
      state.isLoading = false;
      state.sidebarChat = state.sidebarChat.map((item, index) => {
        if ((item.to_id === participants.uid && item.from_id === participants.oa_id) || (item.to_id === participants.oa_id && item.from_id === participants.uid)) {
          item.is_read = 1;
        }
        return item;
      });
    },

    //test
    statusSendMessageLoading(state, action) {
      const participants = action.payload;
      state.conversationContent.push(participants);
      state.isLoading = false;
    },
    statusSendMessageFailed(state, action) {
      const participants = action.payload;
      state.conversationContent = state.conversationContent.map((item, index) => {
        if ((item?.id_temp === participants.id_temp)) {
          item.status = participants.status;
          item.err_message = participants.err_message
          delete item.id_temp
        }

        return item;
      });
      //state.conversationContent.push({ message_id: participants.message_id, time: Date(), src: 1, type: "text", message: participants.message, from_id: participants.from_id, to_id: participants.to_id, display_name: state.infoUserSelected.display_name, page_id: participants.page_id, is_read: participants.is_read, status: participants.status, err_message: participants.err_message });
      state.isLoading = false;
    },
    statusSendMessageSuccess(state, action) {
      const participants = action.payload;
      // Map the conversation content immutably
      state.conversationContent = state.conversationContent.map((item) => {
        if (item?.id_temp === participants.id_temp) {
          // Make a shallow copy of the item to avoid mutating the proxy
          const updatedItem = { ...item };

          updatedItem.message_id = participants.message_id;
          updatedItem.status = participants.status;
          delete updatedItem.id_temp;

          // Avoid accessing a revoked proxy in setTimeout by copying necessary values
          const safeMessageId = updatedItem.message_id;

          setTimeout(() => {
            apiZalo.updateUserResponseMessageItem({ message_id: safeMessageId });
          }, 1500);

          return updatedItem;
        }
        return item;
      });
      //state.conversationContent.push({ message_id: participants.message_id, time: Date(), src: 1, type: "text", message: participants.message, from_id: participants.from_id, to_id: participants.to_id, display_name: state.infoUserSelected.display_name, page_id: participants.page_id, is_read: participants.is_read, status: participants.status });
      state.isLoading = false;
    },
    //end
    statusReceiMessageWebhookSuccess(state, action) {
      const {chat_mode,conversation_id, app_id, message_id, message, from_id, is_read, to_id, from_display_name, to_display_name, time, attachment_url_image, from_avatar, type, message_short, attachments, to_avatar, oa_id } = action.payload;
      if (state?.infoUserSelected?.uid === to_id || state?.infoUserSelected?.uid === from_id) {
        if (!state.conversationContent.some(x => x?.message_id === message_id)) {//check message_id không tồn tại trong conversationContent thì push vào conversationContent
          state.conversationContent.push({ is_read: is_read, oa_id: oa_id, app_id: app_id, attachments: attachments, type: type, message_id: message_id, time: time, src: 1, message: message, attachment_url_image: attachment_url_image, from_id: from_id, from_display_name: from_display_name, to_display_name: to_display_name, to_id: to_id, from_avatar: from_avatar, to_avatar: to_avatar });
        }
      }
      var index_new_chat = -1;
      state.sidebarChat = state.sidebarChat.map((item, index) => {
        if ((item.to_id === to_id && item.from_id === from_id) || (item.to_id === from_id && item.from_id === to_id)) {
          item.oa_id = oa_id;
          item.from_id = from_id;
          item.from_display_name = from_display_name;
          item.to_display_name = to_display_name;
          item.to_avatar = to_avatar;
          item.from_avatar = from_avatar;
          item.to_id = to_id;
          item.message = message;
          item.chat_mode=chat_mode;
          item.conversation_id=conversation_id;
          item.app_id = app_id;
          item.message_short = message_short;
          item.attachments = attachments;
          item.time = time;
          item.type = type;
          item.is_read = is_read
          index_new_chat = index;
        }
        return item;
      });
      if (index_new_chat > -1) {
        var temp = state.sidebarChat[index_new_chat];
        delete state.sidebarChat[index_new_chat];
        state.sidebarChat.unshift(temp);

        //state.sidebarChat[0] = state.sidebarChat[index_new_chat];
        //state.sidebarChat[index_new_chat] = temp;
      } else {
        var new_sidebarChat = state.sidebarChat;
        new_sidebarChat.unshift({ is_read: is_read, oa_id: oa_id, app_id: app_id, attachments: attachments, message_short: message_short, type: type, message_id: message_id, time: time, src: 1, message: message, attachment_url_image: attachment_url_image, from_id: from_id, from_display_name: from_display_name, to_id: to_id, from_avatar: from_avatar, to_avatar: to_avatar, to_display_name: to_display_name });
        state.sidebarChat = new_sidebarChat;
      }
      state.isLoading = false;
      // if(from_id === oa_id){
      //   apiZalo.updateUserResponseMessageItem({message_id});
      // }
    },
    statusReceiMessageWebhookTestSuccess(state, action) {
      const participants = action.payload;
      state.conversationContent.push({ message_id: participants.message_id, time: Date(), src: 1, type: "text", message: participants.message, from_id: state.infoUserSelected.oa_id, to_id: participants.user_id, to_avatar: state.infoUserSelected.avatar_user });
      state.isLoading = false;
    },
    statusEndPageSuccess(state, action) {
      state.endPage = true;
    },
    statusLoadMoreListRecentChatSuccess(state, action) {
      const participants = action.payload;
      if (participants) {
        state.sidebarChat = state.sidebarChat.concat(participants);
      } else {
        state.endListChat = true;
      }
      state.isLoading = false;
    },
    statusListChatEndSuccess(state, action) {
      state.endListChat = true;
    }
  }
});
//user_id: '9039282189603070496', message: 'test 13', contentType: 'text', attachments: Array(0)}
// Reducer
export default slice.reducer;

export function getSidebarChat(oaSelected, params) {
  return async (dispatch) => {
    dispatch(slice.actions.statusRefreshInfo());
    try {
      const response = await apiZalo.getListRecentChat({ oaSelected: oaSelected, paramSearch: params, page: 1 });

      dispatch(slice.actions.statusSidebarChatSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function loadMoreConversation(oaSelected, searchQuery, page) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = { oaSelected, page, paramSearch: searchQuery }
      const response = await apiZalo.getListRecentChat(params);
      if (response.data?.data) {
        if (response.data.data.length === 0) {
          // dispatch(slice.actions.statusListChatEndSuccess());
        } else {
          console.log(await response.data.data)
          dispatch(slice.actions.statusLoadMoreListRecentChatSuccess(response.data.data));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getConversation(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await apiZalo.getConversation(params);
      if (response.data?.data) {
        dispatch(slice.actions.statusIsSelectedSuccess(params));
        dispatch(slice.actions.statusGetConversationSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getMoreMesageConversation(params) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiZalo.getConversation(params);
      if (response.data?.data) {
        if (response.data.data.length === 0) {
          console.log('end page')
          dispatch(slice.actions.statusEndPageSuccess());
        } else {
          console.log('more more page')
          dispatch(slice.actions.statusLoadMoreMessageSuccess(response.data.data));
        }

      }

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function sendMessage(params) {
  return async (dispatch) => {
    const id_temp = Math.floor(Math.random() * Date.now());
    var param_message = {
      id_temp: id_temp,
      page_id: params.page_id,
      from_avatar: "",
      to_avatar: "",
      from_id: params.page_id,
      from_display_name: "",
      to_display_name: "",
      attachments: params?.attachments,
      attachment_temp_blob: params?.attachments?.name ? URL.createObjectURL(params?.attachments) : null,
      to_id: params.user_id,
      message: params.message,
      time: Date(),
      src: 1,
      type: params.contentType,
      message_short: params.message,
      is_read: 1,
      status: -1,
      message_id: null,
      user_response: params?.user_response
    }
    try {

      dispatch(slice.actions.statusSendMessageLoading(param_message));
      const response = await apiZalo.sendMessage(params);

      if (response.data.data.attachment_url_image) {
        param_message = { ...param_message, attachment_url_image: response.data.data.attachment_url_image };

      }
      if (response.data.data.message_id) {
        param_message = { ...param_message, status: 1, message_id: response.data.data.message_id };

        console.log(response.data.data)
        //param_message.message_id = response.data.data.message_id;
        dispatch(slice.actions.statusSendMessageSuccess(param_message));
      }

    } catch (error) {
      param_message = { ...param_message, status: 0, err_message: error?.response ? error?.response?.data : error.message };
      dispatch(slice.actions.statusSendMessageFailed(param_message));
    }
  };
}
export function receiMessageFromWebhookZalo(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      // if (data.message?.attachments) {
      //   data.attachment_url_image = data.message.attachments[0].payload.url;
      // }

      dispatch(slice?.actions?.statusReceiMessageWebhookSuccess(data));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------




